import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

// Lazy imports des widgets
import SimulateurMPAWidget from '../components/SuperBatard/widgets/SimulateurMPAWidget';
import SimulateurRenoEnergieWidget from '../components/SuperBatard/widgets/SimulateurRenoEnergieWidget';
import TravauxConfortWidget from '../components/SuperBatard/widgets/TravauxConfortWidget';
import NouveauLeadWidget from '../components/SuperBatard/widgets/NouveauLeadWidget';

const WIDGET_MAP = {
  'simulateur-mpa': SimulateurMPAWidget,
  'simulateur-reno-energie': SimulateurRenoEnergieWidget,
  'travaux-confort': TravauxConfortWidget,
  'nouveau-lead': NouveauLeadWidget,
};

export default function WidgetEmbedPage() {
  const { widgetId } = useParams();
  const [searchParams] = useSearchParams();
  const societeId = searchParams.get('societe') || '';

  const WidgetComponent = WIDGET_MAP[widgetId];

  if (!WidgetComponent) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <p className="text-xl text-red-400 font-bold">Widget introuvable</p>
          <p className="text-sm text-slate-500 mt-2">ID: {widgetId}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-900 p-4">
      <WidgetComponent societeId={societeId} embedded={true} />
    </div>
  );
}
